import { render, staticRenderFns } from "./BotaoDropdown.vue?vue&type=template&id=32b6ff00&scoped=true&"
import script from "./BotaoDropdown.vue?vue&type=script&lang=js&"
export * from "./BotaoDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BotaoDropdown.vue?vue&type=style&index=0&id=32b6ff00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b6ff00",
  null
  
)

export default component.exports